import { EntityTable } from '@/features/admin/EntityTable';

export function SetoresPage() {
  return (
    <EntityTable
      title="Setores"
      subtitle="Unidades organizacionais da CME e dos centros consumidores"
      endpoint="/v1/sectors"
      queryKey="sectors"
      columns={[
        { key: 'code', label: 'Código', className: 'font-mono text-xs' },
        { key: 'name', label: 'Nome' },
        { key: 'environment', label: 'Ambiente' },
        { key: 'cost_center_erp', label: 'C.Custo ERP', className: 'text-xs text-neutral-500' },
      ]}
      fields={[
        { name: 'code', label: 'Código', type: 'text', required: true, hint: 'até 32 caracteres' },
        { name: 'name', label: 'Nome', type: 'text', required: true },
        {
          name: 'environment', label: 'Ambiente', type: 'select', required: true,
          options: [
            { value: 'DIRTY', label: 'Sujo (Expurgo)' },
            { value: 'CLEAN', label: 'Limpo (Preparo)' },
            { value: 'STERILE', label: 'Estéril (Arsenal)' },
            { value: 'MIXED', label: 'Misto' },
          ],
        },
        { name: 'cost_center_erp', label: 'Centro de custo (ERP)', type: 'text' },
      ]}
    />
  );
}
